import { render, staticRenderFns } from "./userlost.vue?vue&type=template&id=65b637b5"
import script from "./userlost.vue?vue&type=script&lang=js"
export * from "./userlost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports